MeResolver.$inject = ['AuthService'];

export function MeResolver(AuthService) {
    return AuthService.me();
}